import { render, staticRenderFns } from "./LearningPath.vue?vue&type=template&id=1a45979d&scoped=true&"
import script from "./LearningPath.vue?vue&type=script&lang=js&"
export * from "./LearningPath.vue?vue&type=script&lang=js&"
import style0 from "./LearningPath.vue?vue&type=style&index=0&id=1a45979d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a45979d",
  null
  
)

export default component.exports